import React, { useState } from "react";

interface props {
  headerText: string;
  headerTag: string
}

 function HeaderWithTag(props: props) {
  const [show, setHover] = useState(false);
  return (
    <h4
      id={props.headerTag}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      className="text-primary mb-3"
    >
      {props.headerText} {show ? <span>#</span> : <span></span>}
    </h4>
  );
}

export default HeaderWithTag;